import { useEffect, useState } from "react";

// ファイルの object URL を作り、外れたときに解放する
export const useObjectUrl = (file: File) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return url;
};
